/* @flow */
import { combineReducers } from 'redux-immutable';
import { OrderedMap, Map, fromJS } from 'immutable';
import type { Action } from 'trustar/utils/redux-types.js';

import { defaultPayload } from './getters';
import {
  UPDATE_PAGE_FILTERS,
  RESET_PAGE_FILTERS,
  FETCH_WHITELIST_PAGE,
  FETCH_WHITELIST_PAGE_SUCCESS,
  FETCH_WHITELIST_PAGE_FAILURE,
  SAVE_WHITELIST_ENTRY,
  SAVE_WHITELIST_ENTRY_SUCCESS,
  SAVE_WHITELIST_ENTRY_FAILURE,
  SAVE_WHITELIST_ENTRIES_SUCCESS,
  SAVE_WHITELIST_ENTRIES_FAILURE,
  DELETE_WHITELIST_ENTRY,
  DELETE_WHITELIST_ENTRY_SUCCESS,
  DELETE_WHITELIST_ENTRY_FAILURE,
  CLEAR_WHITELIST,
  CLEAR_WHITELIST_SUCCESS,
  CLEAR_WHITELIST_FAILURE,
} from './action-types.js';
import { type WhitelistAction } from './types';

export const entries = (state: OrderedMap<string, any> = OrderedMap(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case FETCH_WHITELIST_PAGE_SUCCESS:
    const items = fromJS(payload.get('items')).toOrderedMap().mapKeys((k, v) => v.get('guid'));
    return fromJS(payload).set('items', items);
  case SAVE_WHITELIST_ENTRY_SUCCESS:
    return state.setIn(['items', payload.get('guid')], payload);
  case DELETE_WHITELIST_ENTRY_SUCCESS:
    return state.deleteIn(['items', payload.get('guid')]);
  case CLEAR_WHITELIST_SUCCESS:
    return OrderedMap(); 
  default:
    return state;
  }
};

export const modalOpen = (state: boolean = false, action: Action<any>) => {
  return state;
};

export const loading = (state: boolean = false, action: Action<any>) => {
  switch (action.type) {
  case FETCH_WHITELIST_PAGE:
  case SAVE_WHITELIST_ENTRY:
  case DELETE_WHITELIST_ENTRY:
  case CLEAR_WHITELIST:
    return true;
  case FETCH_WHITELIST_PAGE_SUCCESS:
  case FETCH_WHITELIST_PAGE_FAILURE:
  case SAVE_WHITELIST_ENTRY_SUCCESS:
  case SAVE_WHITELIST_ENTRY_FAILURE:
  case SAVE_WHITELIST_ENTRIES_SUCCESS:
  case SAVE_WHITELIST_ENTRIES_FAILURE:
  case DELETE_WHITELIST_ENTRY_SUCCESS:
  case DELETE_WHITELIST_ENTRY_FAILURE:
  case CLEAR_WHITELIST_SUCCESS:
  case CLEAR_WHITELIST_FAILURE:
  case UPDATE_PAGE_FILTERS:
  case RESET_PAGE_FILTERS:
    return false;
  default:
    return state;
  }
};

const currentQuery = (state: Map<string, any> = defaultPayload, action: WhitelistAction<*>) => {
  const {
    type,
    payload,
    field
  } = action;

  switch (type) {
  case UPDATE_PAGE_FILTERS:
    if (!field) {
        // Error message for now until better solution
      console.error('Error updating filter, missing field name or \'all\'');
      return state;
    }

    if (field && field.includes('.')) { // Nested fields separated by .
      const updatePath = field.split('.');
      return state.setIn(updatePath, payload);
    }
    if (field && field === 'query') {
      state = state.set('pageNumber', 0);
    }
    return state.set(field, payload.get(field));
  case RESET_PAGE_FILTERS:
    return defaultPayload;
  default:
    return state;
  }
};

export default combineReducers({
  entries,
  loading,
  currentQuery,
  modalOpen,
});



// WEBPACK FOOTER //
// ./src/app/modules/global-whitelist/stores.js